import {Dialog} from 'platform/components';
import {Text} from 'platform/foundation';

import {BlockerFunction} from 'react-router-dom';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps, useBlockNavigating} from 'shared/web';

interface AdUpdateNavigationBlockerProps extends TestIdProps {
  shouldBlock: boolean;
  isUpdateInProgress: boolean;
  onUpdate: () => Promise<boolean>;
}

export function AdUpdateNavigationBlocker(props: AdUpdateNavigationBlockerProps) {
  const shouldBlockNavigation: BlockerFunction = ({currentLocation, nextLocation}) =>
    props.shouldBlock && currentLocation.pathname !== nextLocation.pathname;

  const {blocker} = useBlockNavigating(shouldBlockNavigation);

  const handleLeave = () => blocker.proceed?.();
  const handleStay = () => blocker.reset?.();
  const handleUpdate = () =>
    props.onUpdate().then((isSuccess) => {
      if (isSuccess) {
        blocker.proceed?.();
      }
    });

  return (
    <Dialog
      isOpen={blocker.state === 'blocked'}
      onClose={handleStay}
      size="small"
      data-testid={suffixTestId('adUpdateNavigationBlocker', props)}
      buttons={[
        {
          variant: 'secondary',
          title: i18n.t('general.actions.leave'),
          onClick: handleLeave,
          isDisabled: props.isUpdateInProgress,
          'data-testid': suffixTestId('adUpdateNavigationBlocker-leave', props),
        },
        {
          variant: 'primary',
          title: i18n.t('general.actions.update'),
          onClick: handleUpdate,
          isLoading: props.isUpdateInProgress,
          'data-testid': suffixTestId('adUpdateNavigationBlocker-update', props),
        },
      ]}
    >
      <Text size="small">
        {i18n.t('entity.vehicle.labels.infoChangedUpdateClassifiedsQuestion')}
      </Text>
    </Dialog>
  );
}
